module.exports = __webpack_public_path__ + "static/media/CSK-horiz-tablet-default@2x.1962b728.png";